/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Loop_Mode_2_DescInputs */

const en_mk_loop_mode_2_desc = /** @type {(inputs: Mk_Loop_Mode_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stops at the end of every phase. You approve, or send tasks back with a note. The default.`)
};

const id_mk_loop_mode_2_desc = /** @type {(inputs: Mk_Loop_Mode_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berhenti di akhir tiap fase. Kamu setujui, atau kembalikan task ke agent dengan catatan. Bawaan.`)
};

/**
* | output |
* | --- |
* | "Stops at the end of every phase. You approve, or send tasks back with a note. The default." |
*
* @param {Mk_Loop_Mode_2_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_loop_mode_2_desc = /** @type {((inputs?: Mk_Loop_Mode_2_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Loop_Mode_2_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_loop_mode_2_desc(inputs)
	return en_mk_loop_mode_2_desc(inputs)
});